import mixpanel from 'mixpanel-browser';

const source = 'dashboard:topics';

const getSentimentNameByNumber = key => {
    const sentiments = {
        0: 'Neutral',
        1: 'Positive',
        '-1': 'Negative'
    };

    return sentiments[key];
};

export default {
    trackTopicClick() {
        mixpanel.track(`${source}:topic_clicked`);
    },

    trackSentimentClick(value) {
        const sentiment = getSentimentNameByNumber(value);

        mixpanel.track(`${source}:sentiment_clicked`, {
            Sentiment: sentiment
        });
    },

    //@TODO - waiting for customer feedback
    trackTopicsTrendClick() {
        mixpanel.track(`${source}:trend_clicked`);
    },

    trackPageChange(page) {
        mixpanel.track(`${source}:next_page`, {
            Page: page
        });
    }
};
